import { EDITOR_DEFAULT_FONT_COLOR as K, EDITOR_SUPPORTED_LINK_PROTOCOLS as _t, EDITOR_DEFAULT_LINK_PREFIX as kt } from "./editor-constants.js";
import { addClassStyleAttrs as It, removeClassStyleAttrs as Lt } from "../../common/utils/index.js";
import At from "./EditorToolbarButton.js";
import yt from "./EditorToolbarDropdownButton.js";
import Et from "./EditorToolbarPopoverButton.js";
import { DtIconStopFilled as H, DtIconFontSize as J, DtIconChevronDown as wt, DtIconBraces as Y, DtIconType as j, DtIconSearch as bt, DtIconImage as G, DtIconLink2 as X, DtIconCodeBlock as Z, DtIconQuote as W, DtIconAlignJustify as $, DtIconAlignRight as tt, DtIconAlignCenter as et, DtIconAlignLeft as ot, DtIconListOrdered as it, DtIconListBullet as nt, DtIconStrikethrough as rt, DtIconUnderline as lt, DtIconItalic as st, DtIconBold as at, DtIconQuickReply as ut } from "@dialpad/dialtone-icons/vue3";
import { DialtoneLocalization as Ct } from "../../localization/index.js";
import { resolveComponent as p, resolveDirective as Ot, openBlock as u, createElementBlock as T, mergeProps as B, createVNode as d, withCtx as a, Fragment as _, renderList as y, createBlock as f, createElementVNode as k, normalizeStyle as O, createTextVNode as w, toDisplayString as I, withDirectives as Rt, withKeys as b, withModifiers as L, resolveDynamicComponent as ct, createCommentVNode as D, normalizeClass as Ft } from "vue";
import { _ as xt } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
import Dt from "../combobox/combobox.js";
import St from "../tooltip/tooltip.js";
import vt from "../input/input.js";
import Nt from "../stack/stack.js";
import Ut from "../popover/popover.js";
import Vt from "../button/button.js";
import zt from "../rich-text-editor/rich-text-editor.js";
import Qt from "../list-item/list-item.js";
import Mt from "../dropdown/dropdown-separator.js";
import qt from "../list-item-group/list-item-group.js";
import { RICH_TEXT_EDITOR_OUTPUT_FORMATS as Pt, RICH_TEXT_EDITOR_AUTOFOCUS_TYPES as Kt } from "../rich-text-editor/rich-text-editor-constants.js";
const Ht = {
  compatConfig: { MODE: 3 },
  name: "DtRecipeEditor",
  components: {
    DtListItemGroup: qt,
    DtDropdownSeparator: Mt,
    DtListItem: Qt,
    DtRichTextEditor: zt,
    DtButton: Vt,
    DtPopover: Ut,
    DtStack: Nt,
    DtInput: vt,
    DtTooltip: St,
    DtCombobox: Dt,
    EditorToolbarButton: At,
    EditorToolbarDropdownButton: yt,
    EditorToolbarPopoverButton: Et,
    DtIconQuickReply: ut,
    DtIconBold: at,
    DtIconItalic: st,
    DtIconUnderline: lt,
    DtIconStrikethrough: rt,
    DtIconListBullet: nt,
    DtIconListOrdered: it,
    DtIconAlignLeft: ot,
    DtIconAlignCenter: et,
    DtIconAlignRight: tt,
    DtIconAlignJustify: $,
    DtIconQuote: W,
    DtIconCodeBlock: Z,
    DtIconLink2: X,
    DtIconImage: G,
    DtIconSearch: bt,
    DtIconType: j,
    DtIconBraces: Y,
    DtIconChevronDown: wt,
    DtIconFontSize: J,
    DtIconStopFilled: H
  },
  mixins: [],
  inheritAttrs: !1,
  props: {
    /**
     * Value of the input. The object format should match TipTap's JSON
     * document structure: https://tiptap.dev/guide/output#option-1-json
     */
    modelValue: {
      type: [Object, String],
      default: ""
    },
    /**
     * Whether the input is editable
     */
    editable: {
      type: Boolean,
      default: !0
    },
    /**
     * Descriptive label for the input element
     */
    inputAriaLabel: {
      type: String,
      required: !0,
      default: ""
    },
    /**
     * Additional class name for the input element. Only accepts a String value
     * because this is passed to the editor via options. For multiple classes,
     * join them into one string, e.g. "d-p8 d-hmx96"
     */
    inputClass: {
      type: String,
      default: ""
    },
    /**
     * Whether the input should receive focus after the component has been
     * mounted. Either one of `start`, `end`, `all` or a Boolean or a Number.
     * - `start`  Sets the focus to the beginning of the input
     * - `end`    Sets the focus to the end of the input
     * - `all`    Selects the whole contents of the input
     * - `Number` Sets the focus to a specific position in the input
     * - `true`   Defaults to `start`
     * - `false`  Disables autofocus
     * @values true, false, start, end, all, number
     */
    autoFocus: {
      type: [Boolean, String, Number],
      default: !1,
      validator(t) {
        return typeof t == "string" ? Kt.includes(t) : !0;
      }
    },
    /**
     * Placeholder text
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * Content area needs to dynamically adjust height based on the conversation area height.
     * can be vh|px|rem|em|%
     */
    maxHeight: {
      type: String,
      default: "unset"
    },
    /**
     * Placeholder text for the set link input field
     */
    setLinkPlaceholder: {
      type: String,
      default: ""
    },
    /**
     * Show button to render text as bold
     */
    showBoldButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Show button to render text in italics
     */
    showItalicsButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Show button to underline text
     */
    showUnderlineButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Show button to strike text
     */
    showStrikeButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Show button to render list items
     */
    showListItemsButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Show button to render ordered list items
     */
    showOrderedListButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Show button to align text to the left
     */
    showAlignLeftButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Show button to align text to the center
     */
    showAlignCenterButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Show button to align text to the right
     */
    showAlignRightButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Show button to justify text
     */
    showAlignJustifyButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Show button to add quote format to text
     */
    showQuoteButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Show button to add code block
     */
    showCodeBlockButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Show button to handle quick replies
     */
    showQuickRepliesButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Show button to add an inline image
     */
    showInlineImageButton: {
      type: Boolean,
      default: !1
    },
    /**
     * Show button to add a variable
     */
    showVariableButton: {
      type: Boolean,
      default: !1
    },
    /**
     * Variable categories to display when variable button is clicked
     */
    variableCategories: {
      type: Array,
      default: () => []
    },
    /**
     * Show add link default config.
     */
    showAddLink: {
      type: Object,
      default: () => ({
        showAddLinkButton: !0
      })
    },
    /**
     * Show font style button.
     */
    showFontStyleButton: {
      type: Boolean,
      default: !1
    },
    /**
     * Show font size button.
     */
    showFontSizeButton: {
      type: Boolean,
      default: !1
    },
    /**
     * Show font color button.
     */
    showFontColorButton: {
      type: Boolean,
      default: !1
    },
    /**
     * Available font styles for the font style dropdown.
     */
    fontStyles: {
      type: Array,
      default: () => [
        { name: "Arial", value: null },
        // arial is the default font
        { name: "Georgia", value: "Georgia" },
        { name: "Helvetica", value: "Helvetica" },
        { name: "Verdana", value: "Verdana" },
        { name: "Times New Roman", value: "Times New Roman" }
      ]
    },
    fontSizes: {
      type: Array,
      default: () => [
        { name: "Small", value: "12px" },
        { name: "Normal", value: "15px" },
        { name: "Large", value: "24px" },
        { name: "Huge", value: "36px" }
      ]
    },
    /**
     * Use div tags instead of paragraph tags to show text
     */
    useDivTags: {
      type: Boolean,
      default: !1
    },
    /**
     * Allow Tables to be used in to the editor
     */
    allowTables: {
      type: Boolean,
      default: !1
    },
    /**
     * Allow image resizing
     */
    allowImageResize: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    /**
     * Native focus event
     * @event input
     * @type {String|JSON}
     */
    "focus",
    /**
     * Native blur event
     * @event input
     * @type {String|JSON}
     */
    "blur",
    /**
     * Native input event
     * @event input
     * @type {String|JSON}
     */
    "input",
    /**
     * Event fired to sync the modelValue prop with the parent component
     * @event input
     * @type {String|JSON}
     */
    "update:modelValue",
    /**
     * Quick replies button
     * pressed event
     * @event quick-replies-click
     */
    "quick-replies-click",
    /**
     * Emit when inline image button is clicked
     * @event inline-image-click
     */
    "inline-image-click",
    /**
     * Emit when text input is changed
     * @event text-input
     * @type {String}
     */
    "text-input"
  ],
  data() {
    return {
      internalInputValue: this.modelValue,
      // internal input content
      hasFocus: !1,
      linkOptions: {
        class: "d-recipe-editor__link"
      },
      currentFontColor: void 0,
      showLinkInput: !1,
      fontStyleSearch: "",
      linkInput: "",
      currentButtonRefIndex: 0,
      variableSearchValue: "",
      i18n: new Ct()
    };
  },
  computed: {
    inputLength() {
      return this.internalInputValue.length;
    },
    htmlOutputFormat() {
      return Pt[2];
    },
    flattenedVariableItems() {
      return this.variableCategories ? this.variableCategories.reduce((t, o) => t.concat(o.items || []), []) : [];
    },
    showingTextFormatButtons() {
      return this.showBoldButton || this.showItalicsButton || this.showStrikeButton || this.showUnderlineButton;
    },
    showingAlignmentButtons() {
      return this.showAlignLeftButton || this.showAlignCenterButton || this.showAlignRightButton || this.showAlignJustifyButton;
    },
    showingListButtons() {
      return this.showListItemsButton || this.showOrderedListButton;
    },
    orderedRefs() {
      const t = this.buttonGroups.reduce((function(o, i) {
        return i.buttonGroup.forEach((l) => {
          o.push(this.getButtonRef(i.key, l.selector));
        }, this), o;
      }).bind(this), []);
      return t.push(this.getButtonRef("custom", "link")), t;
    },
    buttonGroups() {
      const t = this.individualButtons.map((o) => ({
        key: o.selector,
        buttonGroup: [o]
      }));
      return [
        { key: "new", buttonGroup: this.newButtons },
        { key: "format", buttonGroup: this.textFormatButtons },
        { key: "alignment", buttonGroup: this.alignmentButtons },
        { key: "list", buttonGroup: this.listButtons },
        ...t
      ].filter((o) => o.buttonGroup.length > 0);
    },
    newButtons() {
      return [
        {
          showBtn: this.showQuickRepliesButton,
          buttonType: "button",
          label: this.i18n.$t("DIALTONE_EDITOR_QUICK_REPLY_BUTTON_LABEL"),
          selector: "quickReplies",
          icon: ut,
          dataQA: "dt-recipe-editor-quick-replies-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_QUICK_REPLY_BUTTON_LABEL"),
          onClick: this.onQuickRepliesClick
        }
      ].filter((t) => t.showBtn);
    },
    textFormatButtons() {
      return [
        {
          showBtn: this.showFontStyleButton,
          buttonType: "popover",
          selector: "fontStyle",
          icon: j,
          dataQA: "dt-recipe-editor-font-style-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_FONT_STYLE_BUTTON_LABEL")
        },
        {
          showBtn: this.showFontSizeButton,
          buttonType: "popover",
          selector: "fontSize",
          icon: J,
          dataQA: "dt-recipe-editor-font-size-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_FONT_SIZE_BUTTON_LABEL")
        },
        {
          showBtn: this.showFontColorButton,
          buttonType: "custom",
          selector: "fontColor",
          icon: H,
          dataQA: "dt-recipe-editor-font-color-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_FONT_COLOR_BUTTON_LABEL"),
          onClick: this.onColorPickerButtonClick
        },
        {
          showBtn: this.showBoldButton,
          buttonType: "button",
          selector: "bold",
          icon: at,
          dataQA: "dt-recipe-editor-bold-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_BOLD_BUTTON_LABEL"),
          onClick: this.onBoldTextToggle
        },
        {
          showBtn: this.showItalicsButton,
          buttonType: "button",
          selector: "italic",
          icon: st,
          dataQA: "dt-recipe-editor-italics-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_ITALICS_BUTTON_LABEL"),
          onClick: this.onItalicTextToggle
        },
        {
          showBtn: this.showUnderlineButton,
          buttonType: "button",
          selector: "underline",
          icon: lt,
          dataQA: "dt-recipe-editor-underline-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_UNDERLINE_BUTTON_LABEL"),
          onClick: this.onUnderlineTextToggle
        },
        {
          showBtn: this.showStrikeButton,
          buttonType: "button",
          selector: "strike",
          icon: rt,
          dataQA: "dt-recipe-editor-strike-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_STRIKE_BUTTON_LABEL"),
          onClick: this.onStrikethroughTextToggle
        }
      ].filter((t) => t.showBtn);
    },
    alignmentButtons() {
      return [
        {
          showBtn: this.showAlignLeftButton,
          buttonType: "button",
          selector: { textAlign: "left" },
          icon: ot,
          dataQA: "dt-recipe-editor-align-left-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_ALIGN_LEFT_BUTTON_LABEL"),
          onClick: () => this.onTextAlign("left")
        },
        {
          showBtn: this.showAlignCenterButton,
          buttonType: "button",
          selector: { textAlign: "center" },
          icon: et,
          dataQA: "dt-recipe-editor-align-center-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_ALIGN_CENTER_BUTTON_LABEL"),
          onClick: () => this.onTextAlign("center")
        },
        {
          showBtn: this.showAlignRightButton,
          buttonType: "button",
          selector: { textAlign: "right" },
          icon: tt,
          dataQA: "dt-recipe-editor-align-right-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_ALIGN_RIGHT_BUTTON_LABEL"),
          onClick: () => this.onTextAlign("right")
        },
        {
          showBtn: this.showAlignJustifyButton,
          buttonType: "button",
          selector: { textAlign: "justify" },
          icon: $,
          dataQA: "dt-recipe-editor-align-justify-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_ALIGN_JUSTIFY_BUTTON_LABEL"),
          onClick: () => this.onTextAlign("justify")
        }
      ].filter((t) => t.showBtn);
    },
    listButtons() {
      return [
        {
          showBtn: this.showListItemsButton,
          buttonType: "button",
          selector: "bulletList",
          icon: nt,
          dataQA: "dt-recipe-editor-list-items-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_BULLET_LIST_BUTTON_LABEL"),
          onClick: this.onBulletListToggle
        },
        {
          showBtn: this.showOrderedListButton,
          buttonType: "button",
          selector: "orderedList",
          icon: it,
          dataQA: "dt-recipe-editor-ordered-list-items-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_ORDERED_LIST_BUTTON_LABEL"),
          onClick: this.onOrderedListToggle
        }
      ].filter((t) => t.showBtn);
    },
    individualButtons() {
      return [
        {
          showBtn: this.showQuoteButton,
          buttonType: "button",
          selector: "blockquote",
          icon: W,
          dataQA: "dt-recipe-editor-blockquote-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_QUOTE_BUTTON_LABEL"),
          onClick: this.onBlockquoteToggle
        },
        {
          showBtn: this.showCodeBlockButton,
          buttonType: "button",
          selector: "codeBlock",
          icon: Z,
          dataQA: "dt-recipe-editor-code-block-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_CODE_BUTTON_LABEL"),
          onClick: this.onCodeBlockToggle
        },
        {
          showBtn: this.showInlineImageButton,
          buttonType: "button",
          selector: "image",
          icon: G,
          dataQA: "dt-recipe-editor-inline-image-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_IMAGE_BUTTON_LABEL"),
          // Handle getting image
          onClick: this.onInsertInlineImageClick
        },
        {
          showBtn: this.showVariableButton,
          buttonType: "popover",
          selector: "variable",
          icon: Y,
          dataQA: "dt-recipe-editor-variable-btn",
          tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_VARIABLE_BUTTON_LABEL")
        }
      ].filter((t) => t.showBtn);
    },
    linkButton() {
      return {
        showBtn: this.showAddLink.showAddLinkButton,
        buttonType: "custom",
        selector: "link",
        icon: X,
        dataQA: "dt-recipe-editor-add-link-btn",
        tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_LINK_BUTTON_LABEL"),
        onClick: this.openLinkInput
      };
    },
    confirmSetLinkButtonLabels() {
      return this.i18n.$ta("DIALTONE_EDITOR_CONFIRM_SET_LINK_BUTTON");
    },
    cancelSetLinkButtonLabels() {
      return this.i18n.$ta("DIALTONE_EDITOR_CANCEL_SET_LINK_BUTTON");
    },
    removeLinkButtonLabels() {
      return this.i18n.$ta("DIALTONE_EDITOR_REMOVE_LINK_BUTTON");
    },
    showAddLinkButtonLabels() {
      return this.i18n.$ta("DIALTONE_EDITOR_ADD_LINK_BUTTON");
    },
    filteredFontStyles() {
      const t = this.fontStyleSearch.toLowerCase();
      return this.fontStyles.filter(
        (o) => o.name.toLowerCase().includes(t)
      );
    },
    filteredCategories() {
      return this.variableCategories.filter(
        (t) => this.getFilteredItemsForCategory(t).length
      );
    },
    colorPickerInput() {
      return document.querySelector(".colorPickerInput");
    },
    isDefaultFontColor() {
      return this.currentFontColor === K;
    },
    actionBarBtn() {
      var o, i;
      const t = ((i = (o = this.$refs[this.orderedRefs[this.currentButtonRefIndex]][0]) == null ? void 0 : o.$refs) == null ? void 0 : i.buttonRef) || this.$refs[this.orderedRefs[this.currentButtonRefIndex]];
      return Array.isArray(t) ? t[0] : t;
    }
  },
  watch: {
    modelValue(t) {
      this.internalInputValue = t;
    }
  },
  methods: {
    removeClassStyleAttrs: Lt,
    addClassStyleAttrs: It,
    onInputFocus(t) {
      t == null || t.stopPropagation();
    },
    removeLink() {
      var t, o, i, l, r;
      (r = (l = (i = (o = (t = this.$refs.richTextEditor) == null ? void 0 : t.editor) == null ? void 0 : o.chain()) == null ? void 0 : i.focus()) == null ? void 0 : l.unsetLink()) == null || r.run(), this.closeLinkInput();
    },
    setLink(t) {
      var r, e, m;
      const o = (r = this.$refs.richTextEditor) == null ? void 0 : r.editor;
      if (t == null || t.preventDefault(), t == null || t.stopPropagation(), !this.linkInput) {
        this.removeLink();
        return;
      }
      _t.find((A) => A.test(this.linkInput)) || (this.linkInput = `${kt}${this.linkInput}`);
      const l = (m = (e = o == null ? void 0 : o.view) == null ? void 0 : e.state) == null ? void 0 : m.selection;
      l.anchor === l.head ? o.chain().focus().insertContentAt(
        l.anchor,
        `<a class="${this.linkOptions.class}" href=${this.linkInput}>${this.linkInput}</a>`
      ).run() : o.chain().focus().extendMarkRange("link").setLink({ href: this.linkInput, class: this.linkOptions.class }).run(), this.closeLinkInput();
    },
    openLinkInput() {
      this.showLinkInput = !0;
    },
    updateInput(t) {
      var o, i, l;
      if (!t)
        return this.closeLinkInput();
      this.linkInput = (l = (i = (o = this.$refs.richTextEditor) == null ? void 0 : o.editor) == null ? void 0 : i.getAttributes("link")) == null ? void 0 : l.href;
    },
    closeLinkInput() {
      var t;
      this.showLinkInput = !1, this.linkInput = "", (t = this.$refs.richTextEditor.editor) == null || t.chain().focus();
    },
    onBoldTextToggle() {
      var t, o;
      (o = (t = this.$refs.richTextEditor) == null ? void 0 : t.editor) == null || o.chain().focus().toggleBold().run();
    },
    onItalicTextToggle() {
      var t;
      (t = this.$refs.richTextEditor) == null || t.editor.chain().focus().toggleItalic().run();
    },
    onUnderlineTextToggle() {
      var t;
      (t = this.$refs.richTextEditor) == null || t.editor.chain().focus().toggleUnderline().run();
    },
    onStrikethroughTextToggle() {
      var t;
      (t = this.$refs.richTextEditor) == null || t.editor.chain().focus().toggleStrike().run();
    },
    onTextAlign(t) {
      var o, i, l, r;
      if ((i = (o = this.$refs.richTextEditor) == null ? void 0 : o.editor) != null && i.isActive({ textAlign: t }))
        return (l = this.$refs.richTextEditor) == null ? void 0 : l.editor.chain().focus().unsetTextAlign().run();
      (r = this.$refs.richTextEditor) == null || r.editor.chain().focus().setTextAlign(t).run();
    },
    onBulletListToggle() {
      var t;
      (t = this.$refs.richTextEditor) == null || t.editor.chain().focus().toggleBulletList().run();
    },
    onOrderedListToggle() {
      var t;
      (t = this.$refs.richTextEditor) == null || t.editor.chain().focus().toggleOrderedList().run();
    },
    onCodeBlockToggle() {
      var t;
      (t = this.$refs.richTextEditor) == null || t.editor.chain().focus().toggleCodeBlock().run();
    },
    onQuickRepliesClick() {
      this.$emit("quick-replies-click");
    },
    onInsertInlineImageClick() {
      this.$emit("inline-image-click");
    },
    insertVariable(t, o) {
      var i;
      (i = this.$refs.richTextEditor) == null || i.editor.chain().focus().insertVariable({
        id: o.id,
        placeholder: o.placeholder || "",
        altText: ""
      }).run();
    },
    insertInlineImage(t) {
      var o;
      (o = this.$refs.richTextEditor) == null || o.editor.chain().focus().setImage({ src: t }).run();
    },
    insertInMessageBody(t) {
      var o;
      (o = this.$refs.richTextEditor) == null || o.editor.chain().focus().insertContent(t).run();
    },
    setCursorPosition(t = null) {
      var o;
      (o = this.$refs.richTextEditor) == null || o.editor.chain().focus(t).run();
    },
    onBlockquoteToggle() {
      var t;
      (t = this.$refs.richTextEditor) == null || t.editor.chain().focus().toggleBlockquote().run();
    },
    onTextInput(t) {
      this.$emit("text-input", t);
    },
    onFocus(t) {
      this.hasFocus = !0, this.$emit("focus", t);
    },
    onBlur(t) {
      this.hasFocus = !1, this.$emit("blur", t);
    },
    onInput(t) {
      this.$emit("input", t), this.$emit("update:modelValue", t);
    },
    onSelected() {
      this.updateFontColorInput();
    },
    getButtonKey(t, o) {
      return `${t}-${JSON.stringify(o)}`;
    },
    // Unique Button Ref Key to identify ref
    getButtonRef(t, o) {
      return `${this.getButtonKey(t, o)}-ref`;
    },
    /**
     * Determines if an element in the action bar button list is focusable with tab key
     * @param {string} refKey - unique identifier for the ref element in DOM
     */
    canFocus(t) {
      return t === this.orderedRefs[this.currentButtonRefIndex];
    },
    shiftActionBarFocusRight() {
      this.shiftButtonRefIndex(1);
    },
    shiftActionBarFocusLeft() {
      this.shiftButtonRefIndex(-1);
    },
    shiftButtonRefIndex(t) {
      const o = this.actionBarBtn, i = (this.currentButtonRefIndex + t) % this.orderedRefs.length;
      this.currentButtonRefIndex = i >= 0 ? i : this.orderedRefs.length + i;
      const l = this.actionBarBtn;
      o.$el.blur(), l.$el.focus();
    },
    onFontStyleSelect(t) {
      var o, i, l, r, e, m;
      t ? (i = (o = this.$refs.richTextEditor) == null ? void 0 : o.editor) == null || i.chain().focus().setFontFamily(t).run() : (r = (l = this.$refs.richTextEditor) == null ? void 0 : l.editor) == null || r.chain().focus().unsetFontFamily().run(), (m = (e = this.$refs.richTextEditor) == null ? void 0 : e.editor) == null || m.commands.focus();
    },
    isCurrentFontFamily(t) {
      var o, i, l, r, e;
      return t ? (e = (r = this.$refs.richTextEditor) == null ? void 0 : r.editor) == null ? void 0 : e.isActive("textStyle", { fontFamily: t }) : !((l = (i = (o = this.$refs.richTextEditor) == null ? void 0 : o.editor) == null ? void 0 : i.getAttributes("textStyle")) != null && l.fontFamily);
    },
    onFontSizeSelect(t) {
      var o, i, l, r;
      (i = (o = this.$refs.richTextEditor) == null ? void 0 : o.editor) == null || i.chain().focus().setFontSize(t).run(), (r = (l = this.$refs.richTextEditor) == null ? void 0 : l.editor) == null || r.commands.focus();
    },
    isCurrentFontSize(t) {
      var o, i, l, r, e;
      return t ? (e = (r = this.$refs.richTextEditor) == null ? void 0 : r.editor) == null ? void 0 : e.isActive("textStyle", { fontSize: t }) : !((l = (i = (o = this.$refs.richTextEditor) == null ? void 0 : o.editor) == null ? void 0 : i.getAttributes("textStyle")) != null && l.fontSize);
    },
    getFilteredItemsForCategory(t) {
      const o = this.variableSearchValue.toLowerCase();
      return t.name.toLowerCase().includes(o) ? t.items : t.items.filter(
        (i) => i.name.toLowerCase().includes(o)
      );
    },
    updateFontColorInput() {
      var t, o, i;
      this.currentFontColor = ((i = (o = (t = this.$refs.richTextEditor) == null ? void 0 : t.editor) == null ? void 0 : o.getAttributes("textStyle")) == null ? void 0 : i.color) || K;
    },
    onColorPickerButtonClick() {
      var t;
      (t = this.colorPickerInput) == null || t.click();
    },
    onColorPickerInput(t) {
      var o, i, l, r;
      (i = (o = this.$refs.richTextEditor) == null ? void 0 : o.editor) == null || i.chain().focus().setColor(t).run(), (r = (l = this.$refs.richTextEditor) == null ? void 0 : l.editor) == null || r.commands.focus(), this.updateFontColorInput();
    }
  }
}, Jt = { class: "d-recipe-editor__popover-content" };
function Yt(t, o, i, l, r, e) {
  const m = p("dt-icon-search"), A = p("dt-input"), R = p("dt-list-item"), S = p("dt-combobox"), v = p("editor-toolbar-popover-button"), dt = p("editor-toolbar-dropdown-button"), E = p("dt-button"), ht = p("dt-dropdown-separator"), ft = p("dt-list-item-group"), pt = p("editor-toolbar-button"), C = p("dt-stack"), Bt = p("dt-tooltip"), mt = p("dt-popover"), gt = p("dt-rich-text-editor"), Tt = Ot("dt-tooltip");
  return u(), T("div", B({ class: "d-recipe-editor" }, e.addClassStyleAttrs(t.$attrs), {
    "data-qa": "dt-recipe-editor",
    role: "presentation",
    onClick: o[7] || (o[7] = (s) => t.$refs.richTextEditor.focusEditor())
  }), [
    d(C, {
      class: "d-recipe-editor__top-bar",
      direction: "row",
      gap: "450"
    }, {
      default: a(() => [
        (u(!0), T(_, null, y(e.buttonGroups, (s) => (u(), f(C, {
          key: s.key,
          direction: "row",
          gap: "300"
        }, {
          default: a(() => [
            (u(!0), T(_, null, y(s.buttonGroup, (n) => {
              var F, N, U, V, z, Q, M, q;
              return u(), T(_, null, [
                n.buttonType === "popover" && n.selector === "fontStyle" ? (u(), f(v, {
                  key: e.getButtonKey(s.key, n.selector),
                  ref_for: !0,
                  ref: e.getButtonRef(s.key, n.selector),
                  "is-active": (N = (F = t.$refs.richTextEditor) == null ? void 0 : F.editor) == null ? void 0 : N.isActive(n.selector),
                  "tooltip-message": n.tooltipMessage,
                  "data-qa": n.dataQA,
                  "popover-data-qa": "dt-recipe-editor-font-style-input-popover",
                  tabindex: e.canFocus(e.getButtonRef(s.key, n.selector)) ? 0 : -1,
                  icon: n.icon,
                  onShiftFocusRight: e.shiftActionBarFocusRight,
                  onShiftFocusLeft: e.shiftActionBarFocusLeft
                }, {
                  content: a(({ close: g }) => [
                    d(S, {
                      label: "",
                      "label-visible": !1,
                      "show-list": !0,
                      "click-on-select": !0,
                      onEscape: (h) => g()
                    }, {
                      input: a(({ inputProps: h }) => [
                        d(A, B({ ref_for: !0 }, h, {
                          modelValue: r.fontStyleSearch,
                          "onUpdate:modelValue": o[0] || (o[0] = (c) => r.fontStyleSearch = c),
                          "root-class": "d-p8 d-pb4 d-w216",
                          type: "search",
                          placeholder: r.i18n.$t("DIALTONE_EDITOR_FONT_STYLE_SEARCH_PLACEHOLDER"),
                          size: "sm",
                          role: "menuitem"
                        }), {
                          leftIcon: a(({ iconSize: c }) => [
                            d(m, { size: c }, null, 8, ["size"])
                          ]),
                          _: 1
                        }, 16, ["modelValue", "placeholder"])
                      ]),
                      list: a(({ listProps: h }) => [
                        k("ul", B({ ref_for: !0 }, h), [
                          (u(!0), T(_, null, y(e.filteredFontStyles, (c) => (u(), f(R, {
                            key: c.name,
                            selected: e.isCurrentFontFamily(c.value),
                            style: O({ fontFamily: c.value || "inherit" }),
                            role: "option",
                            "navigation-type": "arrow-keys",
                            onClick: (P) => {
                              g(), e.onFontStyleSelect(c.value);
                            }
                          }, {
                            default: a(() => [
                              w(I(c.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["selected", "style", "onClick"]))), 128))
                        ], 16)
                      ]),
                      _: 2
                    }, 1032, ["onEscape"])
                  ]),
                  _: 1
                }, 8, ["is-active", "tooltip-message", "data-qa", "tabindex", "icon", "onShiftFocusRight", "onShiftFocusLeft"])) : n.buttonType === "popover" && n.selector === "fontSize" ? (u(), f(dt, {
                  key: e.getButtonKey(s.key, n.selector),
                  ref_for: !0,
                  ref: e.getButtonRef(s.key, n.selector),
                  "is-active": (V = (U = t.$refs.richTextEditor) == null ? void 0 : U.editor) == null ? void 0 : V.isActive(n.selector),
                  "tooltip-message": n.tooltipMessage,
                  "data-qa": n.dataQA,
                  "dropdown-data-qa": "dt-recipe-editor-font-size-input-popover",
                  tabindex: e.canFocus(e.getButtonRef(s.key, n.selector)) ? 0 : -1,
                  icon: n.icon,
                  onShiftFocusRight: e.shiftActionBarFocusRight,
                  onShiftFocusLeft: e.shiftActionBarFocusLeft
                }, {
                  list: a(({ close: g }) => [
                    (u(!0), T(_, null, y(i.fontSizes, (h) => (u(), f(R, {
                      key: h.name,
                      selected: e.isCurrentFontSize(h.value),
                      role: "menuitem",
                      "navigation-type": "arrow-keys",
                      onClick: (c) => {
                        g(), e.onFontSizeSelect(h.value, c);
                      }
                    }, {
                      default: a(() => [
                        k("span", {
                          style: O({ fontSize: h.value })
                        }, I(h.name), 5)
                      ]),
                      _: 2
                    }, 1032, ["selected", "onClick"]))), 128))
                  ]),
                  _: 1
                }, 8, ["is-active", "tooltip-message", "data-qa", "tabindex", "icon", "onShiftFocusRight", "onShiftFocusLeft"])) : n.buttonType === "custom" && n.selector === "fontColor" ? Rt((u(), f(E, {
                  key: e.getButtonKey(s.key, n.selector),
                  ref_for: !0,
                  ref: e.getButtonRef(s.key, n.selector),
                  kind: "muted",
                  importance: "clear",
                  size: "xs",
                  active: (Q = (z = t.$refs.richTextEditor) == null ? void 0 : z.editor) == null ? void 0 : Q.isActive(n.selector),
                  tabindex: e.canFocus(e.getButtonRef(s.key, n.selector)) ? 0 : -1,
                  "aria-label": n.tooltipMessage,
                  "data-qa": n.dataQA,
                  onKeydown: [
                    b(L(e.shiftActionBarFocusRight, ["stop"]), ["right"]),
                    b(L(e.shiftActionBarFocusLeft, ["stop"]), ["left"])
                  ],
                  onClick: (g) => n.onClick()
                }, {
                  icon: a(() => [
                    (u(), f(ct(n.icon), {
                      size: "200",
                      style: O(e.isDefaultFontColor ? {} : { color: r.currentFontColor })
                    }, null, 8, ["style"])),
                    d(A, {
                      value: r.currentFontColor,
                      "root-class": "d-w0 d-h0 d-of-hidden",
                      "input-class": "colorPickerInput d-w0 d-h0 d-p0 d-bar0",
                      "input-wrapper-class": "d-w0 d-h0 d-ba-none",
                      size: "sm",
                      type: "color",
                      onInput: e.onColorPickerInput,
                      onClick: o[1] || (o[1] = L(() => {
                      }, ["stop"]))
                    }, null, 8, ["value", "onInput"])
                  ]),
                  _: 2
                }, 1032, ["active", "tabindex", "aria-label", "data-qa", "onKeydown", "onClick"])), [
                  [Tt, { message: n.tooltipMessage, placement: "top" }]
                ]) : n.buttonType === "popover" && n.selector === "variable" ? (u(), f(v, {
                  key: e.getButtonKey(s.key, n.selector),
                  ref_for: !0,
                  ref: e.getButtonRef(s.key, n.selector),
                  "is-active": !1,
                  "tooltip-message": n.tooltipMessage,
                  "data-qa": n.dataQA,
                  "popover-data-qa": "dt-recipe-editor-variable-popover",
                  tabindex: e.canFocus(e.getButtonRef(s.key, n.selector)) ? 0 : -1,
                  icon: n.icon,
                  onShiftFocusRight: e.shiftActionBarFocusRight,
                  onShiftFocusLeft: e.shiftActionBarFocusLeft
                }, {
                  content: a(({ close: g }) => [
                    d(S, {
                      label: "",
                      "label-visible": !1,
                      "show-list": !0,
                      "click-on-select": !0,
                      onEscape: (h) => g()
                    }, {
                      input: a(({ inputProps: h }) => [
                        d(A, B({ ref_for: !0 }, h, {
                          modelValue: r.variableSearchValue,
                          "onUpdate:modelValue": o[2] || (o[2] = (c) => r.variableSearchValue = c),
                          "root-class": "d-p8 d-pb4 d-w264",
                          type: "search",
                          placeholder: r.i18n.$t("DIALTONE_EDITOR_VARIABLE_POPOVER_SEARCH_PLACEHOLDER"),
                          size: "md",
                          role: "menuitem"
                        }), {
                          leftIcon: a(({ iconSize: c }) => [
                            d(m, { size: c }, null, 8, ["size"])
                          ]),
                          _: 1
                        }, 16, ["modelValue", "placeholder"])
                      ]),
                      list: a(({ listProps: h }) => [
                        k("div", B({ ref_for: !0 }, h), [
                          (u(!0), T(_, null, y(e.filteredCategories, (c, P) => (u(), f(ft, {
                            key: c.name,
                            heading: c.name,
                            "heading-class": "d-headline--sm-compact d-p8"
                          }, {
                            default: a(() => [
                              (u(!0), T(_, null, y(e.getFilteredItemsForCategory(c), (x) => (u(), f(R, {
                                key: c.name + x.name,
                                role: "option",
                                "navigation-type": "arrow-keys",
                                onClick: (jt) => {
                                  e.insertVariable(c.name, x), g();
                                }
                              }, {
                                default: a(() => [
                                  w(I(x.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))), 128)),
                              P < e.filteredCategories.length - 1 ? (u(), f(ht, { key: 0 })) : D("", !0)
                            ]),
                            _: 2
                          }, 1032, ["heading"]))), 128))
                        ], 16)
                      ]),
                      _: 2
                    }, 1032, ["onEscape"])
                  ]),
                  _: 1
                }, 8, ["tooltip-message", "data-qa", "tabindex", "icon", "onShiftFocusRight", "onShiftFocusLeft"])) : n.buttonType === "button" ? (u(), f(pt, {
                  key: e.getButtonKey(s.key, n.selector),
                  ref_for: !0,
                  ref: e.getButtonRef(s.key, n.selector),
                  "is-active": (q = (M = t.$refs.richTextEditor) == null ? void 0 : M.editor) == null ? void 0 : q.isActive(n.selector),
                  "tooltip-message": n.tooltipMessage,
                  "data-qa": n.dataQA,
                  tabindex: e.canFocus(e.getButtonRef(s.key, n.selector)) ? 0 : -1,
                  icon: n.icon,
                  label: n.label,
                  "on-click": n.onClick,
                  onShiftFocusRight: e.shiftActionBarFocusRight,
                  onShiftFocusLeft: e.shiftActionBarFocusLeft
                }, null, 8, ["is-active", "tooltip-message", "data-qa", "tabindex", "icon", "label", "on-click", "onShiftFocusRight", "onShiftFocusLeft"])) : D("", !0)
              ], 64);
            }), 256)),
            o[8] || (o[8] = k("div", { class: "d-recipe-editor__button-group-divider" }, null, -1))
          ]),
          _: 2
        }, 1024))), 128)),
        e.linkButton.showBtn ? (u(), f(C, {
          key: 0,
          direction: "row",
          gap: "300"
        }, {
          default: a(() => [
            d(mt, {
              open: r.showLinkInput,
              "show-close-button": !1,
              "data-qa": "dt-recipe-editor-link-input-popover",
              padding: "none",
              placement: "bottom-start",
              onClick: [
                e.onInputFocus,
                L(e.onInputFocus, ["stop"])
              ],
              onOpened: e.updateInput
            }, {
              anchor: a(() => [
                (u(), f(Bt, {
                  key: e.linkButton.key,
                  message: e.linkButton.tooltipMessage,
                  placement: "top"
                }, {
                  anchor: a(() => {
                    var s, n;
                    return [
                      d(E, {
                        ref: e.getButtonRef("custom", "link"),
                        active: (n = (s = t.$refs.richTextEditor) == null ? void 0 : s.editor) == null ? void 0 : n.isActive(e.linkButton.selector),
                        "aria-label": e.linkButton.tooltipMessage,
                        "data-qa": e.linkButton.dataQA,
                        tabindex: e.canFocus(e.getButtonRef("custom", "link")) ? 0 : -1,
                        importance: "clear",
                        kind: "muted",
                        size: "xs",
                        onClick: o[3] || (o[3] = (F) => e.linkButton.onClick()),
                        onKeydown: [
                          b(L(e.shiftActionBarFocusRight, ["stop"]), ["right"]),
                          b(L(e.shiftActionBarFocusLeft, ["stop"]), ["left"])
                        ]
                      }, {
                        icon: a(() => [
                          (u(), f(ct(e.linkButton.icon), { size: "200" }))
                        ]),
                        _: 1
                      }, 8, ["active", "aria-label", "data-qa", "tabindex", "onKeydown"])
                    ];
                  }),
                  _: 1
                }, 8, ["message"]))
              ]),
              content: a(() => [
                k("div", Jt, [
                  k("span", null, I(e.showAddLinkButtonLabels.title), 1),
                  d(A, {
                    modelValue: r.linkInput,
                    "onUpdate:modelValue": o[4] || (o[4] = (s) => r.linkInput = s),
                    "input-aria-label": e.showAddLinkButtonLabels["aria-label"],
                    placeholder: i.setLinkPlaceholder,
                    "data-qa": "dt-recipe-editor-link-input",
                    "input-wrapper-class": "d-recipe-editor-link__input-wrapper",
                    onClick: [
                      e.onInputFocus,
                      L(e.onInputFocus, ["stop"])
                    ],
                    onFocus: e.onInputFocus,
                    onKeydown: b(e.setLink, ["enter"])
                  }, null, 8, ["modelValue", "input-aria-label", "placeholder", "onClick", "onFocus", "onKeydown"])
                ])
              ]),
              footerContent: a(() => [
                d(C, {
                  direction: "row",
                  gap: "300",
                  class: "d-recipe-editor__popover-footer"
                }, {
                  default: a(() => [
                    d(E, B({
                      "data-qa": "dt-recipe-editor-remove-link-btn",
                      importance: "clear",
                      kind: "muted",
                      size: "sm"
                    }, e.removeLinkButtonLabels, { onClick: e.removeLink }), {
                      default: a(() => [
                        w(I(e.removeLinkButtonLabels.title), 1)
                      ]),
                      _: 1
                    }, 16, ["onClick"]),
                    d(E, B({
                      "data-qa": "dt-recipe-editor-set-link-cancel-btn",
                      importance: "clear",
                      kind: "muted",
                      size: "sm"
                    }, e.cancelSetLinkButtonLabels, { onClick: e.closeLinkInput }), {
                      default: a(() => [
                        w(I(e.cancelSetLinkButtonLabels.title), 1)
                      ]),
                      _: 1
                    }, 16, ["onClick"]),
                    d(E, B({
                      "data-qa": "dt-recipe-editor-set-link-confirm-btn",
                      size: "sm"
                    }, e.confirmSetLinkButtonLabels, { onClick: e.setLink }), {
                      default: a(() => [
                        w(I(e.confirmSetLinkButtonLabels.title), 1)
                      ]),
                      _: 1
                    }, 16, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["open", "onClick", "onOpened"])
          ]),
          _: 1
        })) : D("", !0)
      ]),
      _: 1
    }),
    k("div", {
      style: O({ "max-height": i.maxHeight }),
      class: Ft(["d-recipe-editor__content", { "d-recipe-editor__content-image-resize": i.allowImageResize }])
    }, [
      d(gt, B({
        ref: "richTextEditor",
        modelValue: r.internalInputValue,
        "onUpdate:modelValue": o[5] || (o[5] = (s) => r.internalInputValue = s),
        "allow-font-color": !0,
        "allow-font-family": !0,
        "allow-inline-images": !0,
        "allow-line-breaks": !0,
        "allow-variable": !0,
        "allow-font-size": i.showFontSizeButton,
        "variable-items": e.flattenedVariableItems,
        "hide-link-bubble-menu": !0,
        "auto-focus": i.autoFocus,
        editable: i.editable,
        "input-aria-label": i.inputAriaLabel,
        "input-class": `d-recipe-editor__content-input ${i.inputClass}`,
        link: !0,
        "output-format": e.htmlOutputFormat,
        placeholder: i.placeholder,
        "use-div-tags": i.useDivTags,
        "allow-tables": i.allowTables,
        "allow-image-resize": i.allowImageResize,
        "data-qa": "dt-rich-text-editor"
      }, e.removeClassStyleAttrs(t.$attrs), {
        onTextInput: e.onTextInput,
        onBlur: e.onBlur,
        onFocus: e.onFocus,
        onInput: o[6] || (o[6] = (s) => e.onInput(s)),
        onSelected: e.onSelected
      }), null, 16, ["modelValue", "allow-font-size", "variable-items", "auto-focus", "editable", "input-aria-label", "input-class", "output-format", "placeholder", "use-div-tags", "allow-tables", "allow-image-resize", "onTextInput", "onBlur", "onFocus", "onSelected"])
    ], 6)
  ], 16);
}
const Be = /* @__PURE__ */ xt(Ht, [["render", Yt]]);
export {
  Be as default
};
//# sourceMappingURL=editor.js.map
